export const GA_PROMOTION_ATTRIBUTE = 'data-tracking-id';
export const GA_NAV_FROM_ATTRIBUTE = 'data-track-id';
export const GA_TRACKING_CREATIVE_ATTRIBUTE = 'data-tracking-creative';
